import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { MyProjectComponent } from '../../shared/components/my-project/my-project.component';
import { CanComponentDeactivate } from '../../guards/my-projects-deactivate.guard';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-org-admin-my-projects',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    OrgAdminSidebarComponent,
    PageHeaderComponent,
    MyProjectComponent,
  ],
  templateUrl: './my-projects.component.html',
  styleUrl: './my-projects.component.scss',
})
export class OrgAdminMyProjectsComponent implements CanComponentDeactivate {
  @ViewChild(MyProjectComponent) myProjectComponent!: MyProjectComponent;

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.myProjectComponent) {
      return this.myProjectComponent.canDeactivate();
    }
    return true;
  }
}
